import React from "react";
import "./Footer.css";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useLocalContext } from "../../context/LocalContext";

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

const Footer = () => {
  const { webinfo = {} } = useLocalContext();
  const navigate = useNavigate();

  const year = new Date().getFullYear();

  const address = webinfo?.address || "Remote";
  const email = webinfo?.email || "support@printeroffers.online";
  const phoneText = webinfo?.phone || webinfo?.phonecall || "Contact page";
  const phoneCall = webinfo?.phonecall || webinfo?.phone || "";
  const brand = webinfo?.name || "PrinterOffers.online";

  return (
    <footer className="ftr" aria-label="Footer">
      <div className="ftr__wrap">
        <motion.div
          className="ftr__cta"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.35 }}
        >
          <div>
            <h3 className="ftr__ctaTitle">Ready to discuss your marketing plan?</h3>
            <p className="ftr__ctaText">
              Tell us your goals, budget range, and what you have tried. We will respond with realistic next steps—not a
              one-size-fits-all pitch. No guaranteed ROI or rankings.
            </p>
          </div>

          <div className="ftr__ctaBtns">
            <button type="button" className="ftr__btn ftr__btn--primary" onClick={() => navigate("/contact")}>
              Contact us <span aria-hidden="true">→</span>
            </button>

            <button type="button" className="ftr__btn ftr__btn--ghost" onClick={() => navigate("/services")}>
              Browse services
            </button>
          </div>
        </motion.div>

        <motion.div
          className="ftr__grid"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          transition={{ duration: 0.7, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.22 }}
        >
          <div>
            <h2 className="ftr__brandName">{brand}</h2>
            <p className="ftr__brandText">
              Digital marketing services that combine strategy, creative, and analytics with clear contracts and honest
              limitations.
            </p>

            <div className="ftr__meta">
              <div className="ftr__metaRow">
                <i className="ftr__icon" aria-hidden="true">
                  📍
                </i>
                <div>
                  <p className="ftr__metaLabel">Location</p>
                  <p className="ftr__metaValue">{address}</p>
                </div>
              </div>

              <div className="ftr__metaRow">
                <i className="ftr__icon" aria-hidden="true">
                  ✉️
                </i>
                <div>
                  <p className="ftr__metaLabel">Email</p>
                  <p className="ftr__metaValue">
                    <a href={`mailto:${email}`}>{email}</a>
                  </p>
                </div>
              </div>

              <div className="ftr__metaRow">
                <i className="ftr__icon" aria-hidden="true">
                  📞
                </i>
                <div>
                  <p className="ftr__metaLabel">Phone</p>
                  <p className="ftr__metaValue">
                    {phoneCall ? <a href={`tel:${phoneCall}`}>{phoneText}</a> : <span>{phoneText}</span>}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h4 className="ftr__h4">Services</h4>
            <ul className="ftr__links">
              <li>
                <button type="button" onClick={() => navigate("/services")}>
                  All services
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/services/digital-strategy")}>
                  Strategy &amp; consulting
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/services/seo-content")}>
                  SEO &amp; content
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/services/paid-media")}>
                  Paid media
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="ftr__h4">Company</h4>
            <ul className="ftr__links">
              <li>
                <button type="button" onClick={() => navigate("/about")}>
                  About
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/process")}>
                  Our process
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/contact")}>
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="ftr__h4">Legal</h4>
            <ul className="ftr__links">
              <li>
                <button type="button" onClick={() => navigate("/Terms-and-condition")}>
                  Terms
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/privacy-policy")}>
                  Privacy
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/disclaimer")}>
                  Disclaimer
                </button>
              </li>
            </ul>
          </div>
        </motion.div>

        <div className="ftr__bottom">
          <p className="ftr__copy">
            © {year} {brand}. Marketing results vary; see disclaimer.
          </p>

          <div className="ftr__miniLinks">
            <a href="/privacy-policy" onClick={(e) => { e.preventDefault(); navigate("/privacy-policy"); }}>
              Privacy
            </a>
            <a href="/Terms-and-condition" onClick={(e) => { e.preventDefault(); navigate("/Terms-and-condition"); }}>
              Terms
            </a>
            <a href="/contact" onClick={(e) => { e.preventDefault(); navigate("/contact"); }}>
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
